import React from 'react';
import SMFormFieldTitle from 'components/dashboard/form/SMFormFieldTitle';
import SMFormTextField from 'components/dashboard/form/SMFormTextField';
import SMFormCheckBox from 'components/dashboard/form/SMFormCheckBox';
import SMFormValidationMessage from 'components/dashboard/form/SMFormValidationMessage';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMFormTextAreaWithError from 'components/dashboard/form/SMFormTextAreaWithError';
import update from 'react-addons-update';

class SMORoomEditOptionView extends React.Component {
  
  constructor(props) {
    super(props);
    
    this.state = {
      item: this.props.item,
      errors: this.props.errors,
    };
  }

  textFieldDidEndEditing(e) {
    this.callFormUpdateMethod(e);
  }
  
  textAreaDidEndEditing(e) {
    this.callFormUpdateMethod(e);
  }

  checkBoxDidChangeValue(e) {
    this.callFormUpdateMethod(e);
  }
  
  callFormUpdateMethod(e){
    let mergeData = {};
    if (e.currentTarget.type == 'checkbox') {
      if (e.currentTarget.name == 'status') {
        mergeData[e.currentTarget.name] = e.currentTarget.checked ? 0 : 1;
      } else {
        mergeData[e.currentTarget.name] = e.currentTarget.checked ? 1 : 0;
      }
    } else {
      mergeData[e.currentTarget.name] = e.currentTarget.value;
    }
    var data = update(this.state.item, {$merge: mergeData});
    this.setState({ item: data });
    var payload = {};
    payload[this.props.name] = { 0: data };
    $(document).trigger("SMRoomHandleUpdate", [{ name: this.props.name, payload: payload }]);
  }
  
  handleDeleteItem(e) {
    e.preventDefault();
    if (this.props.isRequiredOption) {
      window.alert(`飲食オプションを削除するにはプランと価格の設定画面で${I18n.t('dashboard.text_000811')}、${I18n.t('dashboard.text_000812')}のチェックを外してください。`);
    } else if (window.confirm(I18n.t("dashboard.notice_000003"))){
      if (this.props.delegate && typeof this.props.delegate.handleDeleteItem === 'function'){
        this.props.delegate.handleDeleteItem(this.props.item, this.props.index, e);
      }
    }
  }
  
  priceDidInput() {
    return this.state.item.created_at ? 1 : 0;
  }
  
  popPriceAlert() {
    if (this.priceDidInput()) {
      window.alert(I18n.t("dashboard.notice_000010"));
    }
  }
  
  render() {
    return(
      <div className="form-casette pt30 pl30 pr30">
        <SMFormFieldTitle title="名前" isRequired={true} />
        <div className="form-box">
          <SMFormTextField name={'name'} value={this.state.item.name} placeholderText={I18n.t("dashboard."+this.props.name+".text_000004")} options={{className:'w400 mr20'}} delegate={this} /> 
          <SMFormCheckBox name={'countable'} id={this.props.name+"_countable-"+this.props.index} value='1' checked={this.state.item.countable == 1} delegate={this} />
          <label htmlFor={this.props.name+'_countable-'+this.props.index} className="form-checkbox">最大数を指定</label>
          <SMFormTextField name={'max_count'} value={this.state.item.max_count} placeholderText="1" options={{className:'w40'}} delegate={this} /> 
          <span className="dashboard-title__supplement ml15">最大数を指定することで、ゲストが数量選択可能になります。</span>
          <SMFormValidationMessage name={this.props.name+"/"+this.props.index+"/name"} errorText={SMFormatHelper.errorText('Room', this.props.name+"/"+this.props.index+"/name", this.props.errors)} />
        </div>

        <SMFormFieldTitle title="説明文" isRequired={true} />
        <SMFormTextAreaWithError name={'description'} options={{className: 'form-textarea w700 h80',}} value={this.state.item.description} errorText={SMFormatHelper.errorText('Room', this.props.name+"/"+this.props.index+"/description", this.props.errors)} placeholderText={I18n.t("dashboard."+this.props.name+".text_000005")} delegate={this} /> 
        
        <SMFormFieldTitle title="価格と単位" subTitle="単位は省略可。税抜き価格を入力してください。" isRequired={true} />
        <div className="form-box">
          ¥ <span onClick={this.popPriceAlert.bind(this)}><SMFormTextField name={'session_price'} value={SMFormatHelper.price(this.state.item.session_price)} placeholderText="5000" options={{className:'w110', disabled:this.priceDidInput()}} delegate={this} /></span>
            <span className="ml5 mr5">/</span>
            <SMFormTextField name={'session_price_unit'} value={this.state.item.session_price_unit} placeholderText={I18n.t("dashboard."+this.props.name+".text_000006")} options={{className:'w110'}} delegate={this} />
            <SMFormValidationMessage name={this.props.name+"/"+this.props.index+"/session_price"} errorText={SMFormatHelper.errorText('Room', this.props.name+"/"+this.props.index+"/session_price", this.props.errors)} />
        </div>
        
        <SMFormFieldTitle title="有効・無効" subTitle="このオプションを一時的に無効にすることができます。" isRequired={false} />
        <div className="form-box">
          <SMFormCheckBox name={'status'} id={this.props.name+"_status-"+this.props.index} value='0' checked={this.state.item.status == 0} delegate={this} />
          <label htmlFor={this.props.name+'_status-'+this.props.index} className="form-checkbox">一時的に無効にする</label>
        </div>
        
        <a href="#" className="form-casette__close" onClick={this.handleDeleteItem.bind(this)}><i className="fa fa-trash-o"></i></a>
      </div>
    );
  }
}

SMORoomEditOptionView.defaultProps = {
  errors: [],
};

export default SMORoomEditOptionView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/rooms/fragments/SMORoomEditOptionView.jsx